/* eslint-disable */
import { withStyles } from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import round from 'lodash/round';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { ORDER_API_DATE_FORMAT } from '../../Constants/Order/Order.constants';
import withServices from '../../Contexts/Services/WithServices.context';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_DOCKET_DETAILS_DIALOG_OPEN, UI_EXPANSION_PANEL_COLLAPSED, UI_EXPANSION_PANEL_EXPANDED } from '../../State/Store/UI/UI.types';
import userProfileSelector from '../../State/Store/UserProfile/Selectors/UserProfileCurrent.selector';
import toDisplayUnit from '../../Support/Converters/ToDisplayUnit/ConvertersToDisplayUnit.support';
import dateOnly from '../../Support/DateTime/DateOnly/DateTimeDateOnly.support';
import envGet from '../../Support/Env/Get/EnvGet.support';
import generateHash from '../../Support/Generators/GenerateHash/GeneratorsGenerateHash.support';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import DeliveryDocketModal from '../DeliveryDocket/DeliveryDocketModal.component';
import I18n from '../I18n/I18n.component';
import OrderConcreteDeliveriesDeliveredSectionPropTypes from './OrderConcreteDeliveriesDeliveredSection.component.props';
import orderConcreteDeliveriesSectionStyles from './OrderConcreteDeliveriesDeliveredSection.component.styles';

const REACT_APP_BORAL_FEATURE_TOGGLE_DOCKETS = envGet({ key: `REACT_APP_BORAL_FEATURE_TOGGLE_DOCKETS` }) === `true`;

/**
 * OrderConcreteDeliveriesDeliveredSectionComponent
 * @export
 * @class OrderConcreteDeliveriesDeliveredSectionComponent
 * @extends {React.Component<OrderConcreteDeliveriesDeliveredSectionComponentComposedProps, OrderConcreteDeliveriesDeliveredSectionComponentState>}
 */
export class OrderConcreteDeliveriesDeliveredSectionComponent extends React.Component {
  preserveScrollRef = React.createRef();

  /**
   * The `props` to seed when any specific prop receives an `undefined` value. NOT a `null` value
   * @static
   * @type {Partial<OrderConcreteDeliveriesDeliveredSectionComponentProps>}
   * @memberof OrderConcreteDeliveriesDeliveredSectionComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`OrderConcreteDeliveriesDeliveredSection`}
   * @memberof OrderConcreteDeliveriesDeliveredSectionComponent
   */
  static displayName = `OrderConcreteDeliveriesDeliveredSection`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof OrderConcreteDeliveriesDeliveredSectionComponent
   */
  static propTypes = OrderConcreteDeliveriesDeliveredSectionPropTypes;

  /**
   * Data specific to the `<OrderConcreteDeliveriesDeliveredSectionComponent />` instance
   * @type {OrderConcreteDeliveriesDeliveredSectionComponentState}
   * @memberof OrderConcreteDeliveriesDeliveredSectionComponent
   */
  state = {
    expanded: false,
  };

  /**
   * Returns the unit of measure
   * @returns {string} The unit of measure
   * @memberof OrderConcreteDeliveriesDeliveredSectionComponent
   */
  getUnitOfMeasure = () => {
    const { currentOrder } = this.props;
    const { details } = currentOrder;
    const { qty } = details || {};
    const { uom } = qty || {};
    return toDisplayUnit(uom);
  };

  /**
   * Returns the unit of measure
   * @param {any} event The event
   * @param {boolean} expanded The expanded state
   * @returns {string} The unit of measure
   * @memberof OrderConcreteDeliveriesDeliveredSectionComponent
   */
  onExpansionPanelChange = (event, expanded) => {
    const { actions } = this.props;
    const type = expanded ? UI_EXPANSION_PANEL_EXPANDED : UI_EXPANSION_PANEL_COLLAPSED;
    actions.uiTriggered({
      payload: {
        data: {
          name: `OrderConcreteDeliveriesDeliveredSection`,
        },
      },
      type,
    });
    this.setState({
      expanded,
    });
  };

  /**
   * Renders the expand icon
   * @returns {React.Component} component
   * @memberof OrderConcreteDeliveriesDeliveredSectionComponent
   */
  renderExpandIcon = () => {
    const { expanded } = this.state;
    if (expanded) {
      return <RemoveIcon />;
    }
    return <AddIcon />;
  };

  /**
   * Opens modal
   * @param {string} ticketCode Ticket code for the docket
   * @returns {void} void
   * @memberof OrderConcreteDeliveriesInTransitSectionComponent
   */
  openDocketDetails = async (ticketCode) => {
    if (!REACT_APP_BORAL_FEATURE_TOGGLE_DOCKETS) {
      return;
    }
    const { userInfo, actions, currentOrder, services } = this.props;
    const { id: userId } = userInfo;
    const { summary } = currentOrder || {};
    if (!summary) {
      return;
    }
    const { startTime, orderLine } = summary;
    const date = dateOnly(startTime, ORDER_API_DATE_FORMAT);
    const orderCode = summary.orderCode.trim();

    const requestPayload = {
      date,
      orderCode,
      orderLine,
      ticketCode,
    };

    this.setState({
      ticketCode,
    });
    actions.uiTriggered({
      payload: {
        data: {
          name: `docketDetailsModalOpen`,
        },
      },
      type: UI_DOCKET_DETAILS_DIALOG_OPEN,
    });

    this.setState({ docketId: ticketCode });
  };

  /**
   * Closes modal
   * @returns {void} void
   * @memberof OrderConcreteDeliveriesInTransitSectionComponent
   */
  closeDocketDetails = () => {
    this.setState({ docket: null, docketId: null });
  };

  /**
   * Renders the delivery load item
   * @param {any} load The current load
   * @returns {React.Component} component
   * @memberof OrderConcreteDeliveriesDeliveredSectionComponent
   */
  renderLoad = (load) => {
    const { classes } = this.props;
    const {
      loadQty,
      ticketCode,
      truck: { code },
    } = load;
    const unitOfMeasure = this.getUnitOfMeasure();
    const uniqueKey = generateHash(load);
    return (
      <Grid
        classes={{ container: classes.detailsItemContainer }}
        className={REACT_APP_BORAL_FEATURE_TOGGLE_DOCKETS && classes.cursorPointer}
        container
        justify="space-between"
        key={uniqueKey}
        onClick={() => this.openDocketDetails(ticketCode)}
      >
        <Grid item sm={3} xs>
          <Typography className={REACT_APP_BORAL_FEATURE_TOGGLE_DOCKETS && classes.textDecorationUnderline}>{ticketCode}</Typography>
          <I18n variant="caption">OrderService.ConcreteDeliveries.Labels.Docket</I18n>
        </Grid>
        <Grid item sm={6} xs>
          <Typography>{`${round(loadQty, 1).toFixed(1)}${unitOfMeasure}`}</Typography>
          <I18n data={{ code }} variant="caption">
            OrderService.ConcreteDeliveries.Labels.Truck
          </I18n>
        </Grid>
      </Grid>
    );
  };

  /**
   * Renders the delivered details section
   * @param {Order} currentDeliveryDetails The current order
   * @returns {React.Component} component
   * @memberof OrderConcreteDeliveriesDeliveredSectionComponent
   */
  renderDelivered = (currentDeliveryDetails) => {
    const { ticketCode } = this.state;
    if (!currentDeliveryDetails || !currentDeliveryDetails.data) {
      return null;
    }
    const {
      data: {
        orders: {
          loads: { delivered },
          orderQty: totalOrdered,
          totalDelivered,
        },
      },
    } = currentDeliveryDetails;
    const unitOfMeasure = this.getUnitOfMeasure();
    const deliveredLoads = delivered.map(this.renderLoad);
    const { classes, currentOrder } = this.props;
    const { docketId } = this.state;
    const { summary } = currentOrder || {};
    const { startTime, orderLine } = summary;
    const ticketDate = dateOnly(startTime, ORDER_API_DATE_FORMAT);
    const orderCode = summary.orderCode.trim();

    return (
      <React.Fragment>
        {docketId && (
          <DeliveryDocketModal
            currentDocket={{
              orderDate: currentOrder.orderKey.substring(0, 8),
              orderCode,
              orderLine,
              docketNumber: ticketCode,
            }}
            currentAccount={(currentOrder && currentOrder.summary) ? currentOrder.summary.customerCode : ''}
            onCloseDetails={this.closeDocketDetails}
            open={!!docketId}
          />
        )}
        <ExpansionPanel classes={{ root: classes.section }} onChange={this.onExpansionPanelChange}>
          <ExpansionPanelSummary classes={{ root: classes.detailsHeader }} expandIcon={totalDelivered > 0 && this.renderExpandIcon()}>
            <Grid alignItems="center" container justify="space-between" spacing={4}>
              <Grid item sm={3} xs>
                <I18n variant="body1">OrderService.ConcreteDeliveries.Labels.DeliveredHeader</I18n>
              </Grid>
              <Grid item sm={6} xs>
                <Typography>{`${round(totalDelivered, 1).toFixed(1)}${unitOfMeasure} / ${round(totalOrdered, 1).toFixed(1)}${unitOfMeasure}`}</Typography>
              </Grid>
            </Grid>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.noPadding}>
            <div className={classes.detailsContainer}>{deliveredLoads}</div>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </React.Fragment>
    );
  };

  /**
   * Render the component
   * @returns {React.Component} The rendered `<OrderConcreteDeliveriesDeliveredSectionComponent />`
   * @memberof OrderConcreteDeliveriesDeliveredSectionComponent
   */
  render() {
    const { currentDeliveryDetails } = this.props;
    return this.renderDelivered(currentDeliveryDetails);
  }
}

/** @type {React.ComponentClass<OrderConcreteDeliveriesDeliveredSectionComponentProps>} */
const OrderConcreteDeliveriesDeliveredSection = compose(
  withServices,
  withStyles(themeCreateInjectableStyles(orderConcreteDeliveriesSectionStyles), { withTheme: true }),
  connect(
    () => (state, ownProps) => ({
      userInfo: userProfileSelector(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
        },
        dispatch,
      ),
    }),
  ),
)(OrderConcreteDeliveriesDeliveredSectionComponent);

export default OrderConcreteDeliveriesDeliveredSection;
